export default function DragEvent(type, _a) {
    var sourceEvent = _a.sourceEvent, subject = _a.subject, target = _a.target, identifier = _a.identifier, active = _a.active, x = _a.x, y = _a.y, dx = _a.dx, dy = _a.dy, dispatch = _a.dispatch;
    Object.defineProperties(this, {
        type: { value: type, enumerable: true, configurable: true },
        sourceEvent: { value: sourceEvent, enumerable: true, configurable: true },
        subject: { value: subject, enumerable: true, configurable: true },
        target: { value: target, enumerable: true, configurable: true },
        identifier: { value: identifier, enumerable: true, configurable: true },
        active: { value: active, enumerable: true, configurable: true },
        x: { value: x, enumerable: true, configurable: true },
        y: { value: y, enumerable: true, configurable: true },
        dx: { value: dx, enumerable: true, configurable: true },
        dy: { value: dy, enumerable: true, configurable: true },
        _: { value: dispatch }
    });
}
DragEvent.prototype.on = function () {
    var value = this._.on.apply(this._, arguments);
    return value === this._ ? this : value;
};
